module.exports = __webpack_public_path__ + "static/media/L diag area.86a79a39.jpg";